import type { Locale } from '@atlassian/jira-common-constants/src/supported-locales';
import { formatDistanceWithLocale } from '@atlassian/jira-platform-utils-date-fns';
import type { Timestamp } from '../../../../../../common/types';

export const getLastUpdateText = (lastUpdated: Timestamp, locale: Locale): string =>
	formatDistanceWithLocale(new Date(lastUpdated), new Date(), locale, true);
